<template>
  <div class="xl:w-fit flex flex-none flex-row items-center">
    <div
        class="h-[36px] w-[36px] rounded-full bg-complementary-600 flex-none ml-[8px] flex items-center justify-center p-[9px]"
    >
      <icon-mishnat class="xl:w-[19px]"/>
    </div>
    <div class="xl:w-[152px] flex flex-col relative group">
      <tooltip-small
          :class="[
          isTooltipVisible ? 'group-hover:opacity-100 group-hover:z-10' : '',
        ]"
          :positionBottom="true"
          :tooltipText="`${title}`"
          class="tooltip absolute left-[0] bottom-[55px] opacity-0 -z-10"
      />
      <h2
          ref="textElement"
          class="font-bold text-xl text-complementary-900 truncate"
      >
        {{ title }}
      </h2>
      <p class="font-regular text-sm text-complementary-900 mt-[-5px]">
        המכירה השבועית
      </p>
    </div>
  </div>
</template>

<script>
import IconMishnat from "@/components/Global/IconMishnat.vue";
import TooltipSmall from "@/components/Global/TooltipSmall.vue";

export default {
  name: "title-section",
  components: {TooltipSmall, IconMishnat},
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isTooltipVisible: false,
    };
  },
  methods: {
    updateTooltipVisibility() {
      this.$nextTick(() => {
        const textElement = this.$refs.textElement;
        if (textElement) {
          const isTextOverflowing =
              textElement.scrollWidth > textElement.offsetWidth;
          this.isTooltipVisible = isTextOverflowing;
        }
      });
    },
  },
  mounted() {
    this.updateTooltipVisibility();
  },
};
</script>

<style>
</style>